/**
 * Search tuning, kept in step with `genai-studio-v2`'s `consts/search.ts` —
 * both surfaces query the same endpoint, so a term typed here and the same term
 * typed in the miniapp must return the same thing.
 */

/** Ranking formula the shop search expects; not tuned per query. */
export const SEARCH_PREMIUM_FORMULA = 'hs_alt_default';

/**
 * Scopes the search to GenAI Studio's own catalogue.
 *
 * The miniapp's package id, deliberately, even though this request goes out
 * from gen.ai: `source` selects which app's items are indexed, not which app is
 * asking. Sending this site's own id would match nothing.
 */
export const SEARCH_SOURCE = 'com.picsart.genai-studiov2';

/** `limit` query param — applied per package type, so up to 2× this in total. */
export const SEARCH_RESULTS_LIMIT = 30;

/** How many past terms the idle state offers. */
export const RECENT_SEARCH_LIMIT = 8;

/** Placeholder rows rendered while a search is in flight. */
export const SEARCH_SKELETON_COUNT = 6;

/** The results page, and the only route whose `?q=` seeds the header field. */
export const SEARCH_PATH = '/search';

/** Keystroke settle time before a live search fires. */
export const SEARCH_DEBOUNCE_MS = 300;
